/* ============================================================
   ERIKA VIKMAN — storefront interactivity
   - Custom slide-in cart drawer (Shopify AJAX Cart API)
   - Size / variant selection + quick add
   - Product gallery thumbnails
   ============================================================ */
(function () {
  'use strict';

  var EV = (window.EV = window.EV || {});
  EV.moneyFormat = EV.moneyFormat || '€{{amount}}';

  /* ---------- money ---------- */
  function formatMoney(cents) {
    var fmt = EV.moneyFormat || '€{{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      var amount = cents / 100;
      var noDecimals = name.indexOf('no_decimals') !== -1;
      var useComma = name.indexOf('comma_separator') !== -1;
      var useSpace = name.indexOf('space_separator') !== -1;
      var thousands = useComma ? '.' : (useSpace ? ' ' : ',');
      var decimal = useComma ? ',' : '.';
      var value = noDecimals ? Math.round(amount).toString() : amount.toFixed(2);
      var parts = value.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
    });
  }

  /* ---------- cart drawer ---------- */
  function drawer() { return document.querySelector('[data-ev-drawer]'); }
  function overlay() { return document.querySelector('[data-ev-cart-overlay]'); }

  function openCart() {
    if (drawer()) drawer().classList.add('is-open');
    if (overlay()) overlay().classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeCart() {
    if (drawer()) drawer().classList.remove('is-open');
    if (overlay()) overlay().classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }
  EV.openCart = openCart;
  EV.closeCart = closeCart;

  /* ---------- mobile menu drawer ---------- */
  function menuDrawer() { return document.querySelector('[data-ev-menu-drawer]'); }
  function menuOverlay() { return document.querySelector('[data-ev-menu-overlay]'); }
  function openMenu() {
    var d = menuDrawer(), o = menuOverlay(), t = document.querySelector('[data-ev-menu-open]');
    if (o) { o.hidden = false; requestAnimationFrame(function () { o.classList.add('is-open'); }); }
    if (d) { d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); }
    if (t) t.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeMenu() {
    var d = menuDrawer(), o = menuOverlay(), t = document.querySelector('[data-ev-menu-open]');
    if (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); }
    if (o) { o.classList.remove('is-open'); setTimeout(function () { o.hidden = true; }, 280); }
    if (t) t.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
  }
  EV.openMenu = openMenu;
  EV.closeMenu = closeMenu;

  function renderCart(cart) {
    var countEls = document.querySelectorAll('[data-ev-cart-count]');
    countEls.forEach(function (el) { el.textContent = cart.item_count; });

    var itemsEl = document.querySelector('[data-ev-cart-items]');
    var subtotalEl = document.querySelector('[data-ev-cart-subtotal]');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.items_subtotal_price);
    if (!itemsEl) return;

    var S = (EV && EV.strings) || {};
    if (!cart.items.length) {
      itemsEl.innerHTML =
        '<div class="ev-cart-empty"><div class="ev-cart-empty__big">' + (S.empty || 'Empty') + '</div>' +
        '<div style="font:600 14px Archivo,sans-serif">' + (S.emptySub || 'Your bag is waiting for some heat.') + '</div></div>';
      return;
    }

    itemsEl.innerHTML = cart.items.map(function (it) {
      var opt = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
      return (
        '<div class="ev-line">' +
          '<div class="ev-line__img"><img src="' + (it.image ? it.image.replace(/(\.[^.]+)(\?.*)?$/, '_120x$1') : '') + '" alt=""></div>' +
          '<div class="ev-line__mid">' +
            '<div class="ev-line__name">' + it.product_title + '</div>' +
            (opt ? '<div class="ev-line__opt">' + opt + '</div>' : '') +
            '<div class="ev-qty">' +
              '<button data-ev-qty-dec data-key="' + it.key + '" aria-label="' + (S.decrease || 'Decrease') + '">–</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button data-ev-qty-inc data-key="' + it.key + '" aria-label="' + (S.increase || 'Increase') + '">+</button>' +
            '</div>' +
          '</div>' +
          '<div class="ev-line__end">' +
            '<div class="ev-line__total">' + formatMoney(it.final_line_price) + '</div>' +
            '<button class="ev-line__remove" data-ev-remove data-key="' + it.key + '">' + (S.remove || 'Remove') + '</button>' +
          '</div>' +
        '</div>'
      );
    }).join('');
  }
  EV.renderCart = renderCart;

  function refreshCart(open) {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); if (open) openCart(); return cart; });
  }
  EV.refreshCart = refreshCart;

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (cart) { renderCart(cart); return cart; });
  }

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: quantity || 1 }] })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) { throw new Error(data.description || data.message || 'Could not add to cart'); }
        return data;
      });
    }).then(function () { return refreshCart(true); });
  }
  EV.addToCart = addToCart;

  /* ---------- variant / size picker ---------- */
  function syncPicker(picker) {
    var selected = picker.querySelector('[data-ev-variant][aria-pressed="true"]');
    var scope = picker.closest('[data-ev-product]') || picker;
    var addBtn = scope.querySelector('[data-ev-add]');
    if (!addBtn) return;
    if (selected) {
      addBtn.classList.add('is-ready');
      addBtn.dataset.variantId = selected.getAttribute('data-ev-variant');
      addBtn.textContent = (addBtn.dataset.readyLabel || 'Add') + ' · ' + selected.textContent.trim();
    } else {
      addBtn.classList.remove('is-ready');
      addBtn.removeAttribute('data-variant-id');
      addBtn.textContent = addBtn.dataset.idleLabel || 'Select a size';
    }
  }

  /* ---------- product gallery ---------- */
  function selectThumb(thumb) {
    var gallery = thumb.closest('[data-ev-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-ev-main-img]');
    if (main) main.src = thumb.getAttribute('data-src');
    gallery.querySelectorAll('[data-ev-thumb]').forEach(function (t) {
      t.setAttribute('aria-pressed', t === thumb ? 'true' : 'false');
    });
  }

  /* ---------- delegated events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-ev-cart-open]');
    if (t) { e.preventDefault(); refreshCart(true); return; }

    if (e.target.closest('[data-ev-cart-close]')) { e.preventDefault(); closeCart(); return; }

    if (e.target.closest('[data-ev-menu-open]')) { e.preventDefault(); openMenu(); return; }
    if (e.target.closest('[data-ev-menu-close]') || e.target.closest('[data-ev-menu-overlay]')) { e.preventDefault(); closeMenu(); return; }
    if (e.target.closest('[data-ev-menu-link]')) { closeMenu(); return; }

    var size = e.target.closest('[data-ev-variant]');
    if (size) {
      e.preventDefault();
      var picker = size.closest('[data-ev-variant-picker]');
      picker.querySelectorAll('[data-ev-variant]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      size.setAttribute('aria-pressed', 'true');
      syncPicker(picker);
      return;
    }

    var add = e.target.closest('[data-ev-add]');
    if (add) {
      e.preventDefault();
      var vid = add.dataset.variantId;
      if (!vid || vid === 'null') return;
      add.disabled = true;
      addToCart(vid, 1)
        .catch(function (err) { console.error('[EV cart]', err); alert(err.message || 'Could not add to cart'); })
        .finally(function () { add.disabled = false; });
      return;
    }

    var inc = e.target.closest('[data-ev-qty-inc]');
    var dec = e.target.closest('[data-ev-qty-dec]');
    var rem = e.target.closest('[data-ev-remove]');
    if (inc || dec || rem) {
      e.preventDefault();
      var el = inc || dec || rem;
      var key = el.getAttribute('data-key');
      var line = el.closest('.ev-line');
      var current = line ? parseInt(line.querySelector('.ev-qty span').textContent, 10) : 1;
      var next = rem ? 0 : current + (inc ? 1 : -1);
      changeLine(key, next);
      return;
    }

    var thumb = e.target.closest('[data-ev-thumb]');
    if (thumb) { e.preventDefault(); selectThumb(thumb); return; }

    if (e.target.closest('[data-ev-open-sizechart]')) { e.preventDefault(); toggleSizeChart(true); return; }
    if (e.target.closest('[data-ev-close-sizechart]')) { e.preventDefault(); toggleSizeChart(false); return; }
  });

  /* ---------- size chart popup ---------- */
  function toggleSizeChart(open) {
    var modal = document.querySelector('[data-ev-sizechart]');
    var ov = document.querySelector('[data-ev-sizechart-overlay]');
    if (modal) modal.classList.toggle('is-open', open);
    if (ov) ov.classList.toggle('is-open', open);
    document.documentElement.style.overflow = open ? 'hidden' : '';
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeCart(); toggleSizeChart(false); closeMenu(); }
  });

  /* ---------- tour date ordering ---------- */
  function sortTour() {
    document.querySelectorAll('[data-ev-tour-rows]').forEach(function (container) {
      var rows = Array.prototype.slice.call(container.querySelectorAll('[data-ev-tour-row]'));
      rows.sort(function (a, b) {
        var da = a.getAttribute('data-date') || '';
        var db = b.getAttribute('data-date') || '';
        return da < db ? -1 : da > db ? 1 : 0;
      });
      rows.forEach(function (r) { container.appendChild(r); });
    });
  }

  /* preselect smallest available size; mark sold out if none available */
  function initPicker(picker) {
    var scope = picker.closest('[data-ev-product]') || picker;
    var addBtn = scope.querySelector('[data-ev-add]');
    var buttons = Array.prototype.slice.call(picker.querySelectorAll('[data-ev-variant]'));
    var firstAvail = buttons.filter(function (b) { return !b.disabled; })[0];
    if (firstAvail) {
      buttons.forEach(function (b) { b.setAttribute('aria-pressed', b === firstAvail ? 'true' : 'false'); });
      if (addBtn) addBtn.disabled = false;
      syncPicker(picker);
    } else if (addBtn) {
      addBtn.classList.remove('is-ready');
      addBtn.removeAttribute('data-variant-id');
      addBtn.textContent = 'Sold Out';
      addBtn.disabled = true;
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('[data-ev-cart-items]')) refreshCart(false);
    document.querySelectorAll('[data-ev-variant-picker]').forEach(initPicker);
    sortTour();
  });
})();
